// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #chart::-webkit-scrollbar {
  width: 12px;
}

#chart::-webkit-scrollbar-thumb {
  background-color: 'red';
  border-radius: 6px;
}

#chart::-webkit-scrollbar-track {
  background-color: 'green';
} */

/* .highcharts-scrollbar {
  height: 6px;
}
.highcharts-scrollbar-thumb {
  fill: #888;
}

.highcharts-scrollbar-track {
  fill: #f0f0f0;
} */
`, "",{"version":3,"sources":["webpack://./src/assets/third-party/highchart.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;GAWG;;AAEH;;;;;;;;;GASG","sourcesContent":["/* #chart::-webkit-scrollbar {\n  width: 12px;\n}\n\n#chart::-webkit-scrollbar-thumb {\n  background-color: 'red';\n  border-radius: 6px;\n}\n\n#chart::-webkit-scrollbar-track {\n  background-color: 'green';\n} */\n\n/* .highcharts-scrollbar {\n  height: 6px;\n}\n.highcharts-scrollbar-thumb {\n  fill: #888;\n}\n\n.highcharts-scrollbar-track {\n  fill: #f0f0f0;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
